<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3>
          <i class="fas fa-users-cog"></i> Movimentação de Associados -
          Clusterização
        </h3>
      </div>
    </div>

    <Forms
      ref="frmGroup"
      :title="'MOVIMENTAÇÃO DE ASSOCIADOS'"
      :showSaveButton="true"
      v-on:Save="openConfirmationModal"
    >
      <div class="form-group row">
        <div class="col-md-4">
          <label
            ><small
              v-show="form.paId.required"
              class="text-danger"
              >*</small
            >
            PA:</label
          >
          <div class="input-group">
            <v-select
              v-model="form.paId.value"
              :options="form.paId.options"
              class="w-100"
              label="text"
              :reduce="(opt) => opt.value"
            >
              <template v-slot:no-options>Nenhum pa encontrado.</template>
            </v-select>
          </div>
        </div>

        <div class="col-md-4 pb-3">
          <label
            ><small
              v-show="form.clusterId.required"
              class="text-danger"
              >*</small
            >
            Clusters:</label
          >
          <div class="input-group">
            <v-select
              v-model="form.clusterId.value"
              :options="form.clusterId.options"
              class="w-100"
              label="text"
              :reduce="(opt) => opt.value"
            >
              <template v-slot:no-options>Nenhum Cluster encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>

      <div class="form-group row pt-3">
        <div class="col-md-3">
          <label>Nome Associado</label>
          <b-form-input
            type="text"
            :placeholder="'Busque pelo Nome associado'"
            v-model="form.nomeAssociado.value"
          ></b-form-input>
        </div>
        <div class="col-md-3">
          <NxSelectFuncionario
            :variable="employeeTypes.GERENTE"
            :multiple="false"
            @update:value="handleSelectGerente($event)"
          />
        </div>
        <div class="col-md-2">
          <label>Faixa de Renda:</label>
          <div class="input-group">
            <money
              :placeholder="$lang.Currency.Placeholder"
              class="form-control text-bold"
              max-length="12"
              v-model.lazy="computedRendaInicial"
              v-bind="$lang.Currency.Format"
            ></money>
            <money
              :placeholder="$lang.Currency.Placeholder"
              class="form-control text-bold"
              max-length="12"
              v-model.lazy="computedRendaFinal"
              v-bind="$lang.Currency.Format"
            ></money>
          </div>
        </div>
        <div class="col-md-2">
          <label>Produtor Rural:</label>
          <b-form-radio-group
            v-model="form.isProdutorRural.value"
            aria-describedby="isProdutorRural"
            :required="form.isProdutorRural.required"
          >
            <b-form-radio value="true">Sim</b-form-radio>
            <b-form-radio value="false">Não</b-form-radio>
          </b-form-radio-group>
        </div>
        <div class="col-md-2">
          <label>Tipo Pessoa:</label>
          <b-form-radio-group
            v-model="form.tipoPessoa.value"
            aria-describedby="isProdutorRural"
            :required="form.tipoPessoa.required"
          >
            <b-form-radio value="PF">PF</b-form-radio>
            <b-form-radio value="PJ">PJ</b-form-radio>
          </b-form-radio-group>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 d-flex">
          <div>
            <button
              type="button"
              class="btn btn-third btn-sm"
              v-b-tooltip.hover
              :title="'Pesquisar'"
              @click.prevent="onSearch"
            >
              <i class="fas fa-search"></i>
              <span class="d-md-down-none">
                {{ $lang.Common.Buttons.Search }}
              </span>
            </button>
            <button
              type="button"
              class="btn btn-default btn-sm text-secondary"
              v-on:click="onClear"
              v-b-tooltip.hover
              :title="$lang.Common.Tooltip.ButtonClear"
            >
              <i class="fa fa-minus-circle"></i>
              <span class="d-md-down-none">
                {{ $lang.Common.Buttons.Clear }}
              </span>
            </button>
          </div>
        </div>
      </div>

      <!-- <div class="row justify-content-start">
        <div class="col-md-3 pb-2 pt-2">
          <div class="input-group">
            <b-form-input type="text"
                            :placeholder="'Digite a busca'"
                            v-model="searchValue">
            </b-form-input>
          </div>
        </div>
      </div> -->
      <div
        id="associate-list"
        style="overflow-y: auto; max-height: 70vh"
      >
        <table
          class="table table-hover"
          style="border: 1px solid #dcdede"
        >
          <thead
            class="thead-third"
            style="border: solid 1px #0277bd; height: 44px"
          >
            <tr>
              <th class="text-center col-1">
                <input
                  type="checkbox"
                  v-model="selectAll"
                />
              </th>
              <th class="text-center">Nome</th>
              <th class="text-center">PA</th>
              <th class="text-center">
                {{ $t('associates.number') }}
              </th>
              <th class="text-center">Tipo Pessoa</th>
              <th class="text-center">Cluster</th>
              <th class="text-center">Renda</th>
            </tr>
          </thead>
          <tr
            v-for="associado in associados"
            :key="associado.id"
          >
            <td
              v-if="allSelected"
              class="text-center col-1"
            >
              <input
                v-model="allSelected"
                type="checkbox"
                checked
                disabled
              />
            </td>
            <td
              v-else
              class="text-center col-1"
            >
              <input
                v-model="selected"
                :value="associado.id"
                type="checkbox"
              />
            </td>
            <td class="text-center">{{ associado.nome }}</td>
            <td class="text-center">{{ associado.pa }}</td>
            <td class="text-center">{{ associado.numId }}</td>
            <td class="text-center">{{ associado.tipoPessoa }}</td>
            <td class="text-center">{{ associado.clusterAtual }}</td>
            <td class="text-center">{{ associado.rendaBrutaMensal }}</td>
          </tr>
        </table>
      </div>
      <AssociatePagination
        ref="AssociatePagination"
        @LoadPage="LoadPage"
        class="pt-3"
      ></AssociatePagination>
      <AddConfirmation
        ref="AddConfirmationModal"
        :warnText="`Confirmar movimentação de  ${
          allSelected ? 'todos' : this.selected.length
        } associados com os filtros selecionados`"
        :saveFunction="updateClusters"
      />
    </Forms>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import LinkForm from './link-form'

import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'
import employeeTypes from '@/enums/enumEmployeeTypes.js'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import ClusterRepository from '@/shared/http/repositories/configurations/cluster'
import PARepository from '@/shared/http/repositories/configurations/pa'
import AssociatePagination from '@/views/private/associate/pagination/AssociatePagination.vue'
import NxSelectFuncionario from '../../../../../components/nexum/components/custom-selects/NxSelectFuncionario.vue'
import EnvironmentRepository from '../../../../../shared/http/repositories/access/environment'

const dataModel = {
  clusterId: null,
  paId: null,
  filters: null
}

const dataFilter = {
  paId: null,
  nomeAssociado: null,
  gerenteId: null,
  isProdutorRural: null,
  tipoPessoa: null
}
export default {
  name: 'linkClusters',
  mixins: [ActionsForm],
  data () {
    return {
      warnMessage: '',
      title: '',
      form: LinkForm,
      data: dataModel,
      dataFilters: dataFilter,
      rendaInicial: null,
      rendaFinal: null,
      selected: [],
      searchValue: '',
      associados: [],
      pageLimit: 50,
      pageIndex: 0,
      currentPage: 0,
      totalElements: 0,
      numberOfElementsDisplayed: 0,
      offset: 0,
      allSelected: false,
      employeeTypes: employeeTypes,
      tipoGerente: null
    }
  },
  components: {
    NxSelectFuncionario,
    AssociatePagination,
    AddConfirmation
  },
  computed: {
    selectAll: {
      get: function () {
        return this.allSelected
      },
      set: function () {
        if (this.allSelected) {
          this.allSelected = false
        } else {
          this.allSelected = true
        }
      }
    },
    computedRendaInicial: {
      get: function () {
        // Retorna 0 para o componente filho se rendaInicial for null
        return this.rendaInicial === null ? 0 : this.rendaInicial
      },
      set: function (value) {
        // Se o valor for zero, seta rendaInicial como null
        this.rendaInicial = value === 0 ? null : value
      }
    },
    computedRendaFinal: {
      get: function () {
        // Retorna 0 para o componente filho se rendaInicial for null
        return this.rendaFinal === null ? 0 : this.rendaFinal
      },
      set: function (value) {
        // Se o valor for zero, seta rendaInicial como null
        this.rendaFinal = value === 0 ? null : value
      }
    }
  },
  methods: {
    onLoad () {
      loading.push()
      this.$refs.AssociatePagination.pageLimit = this.pageLimit
      this.$refs.AssociatePagination.totalElements = this.totalElements

      ClusterRepository.GetAll()
        .then((res) => {
          this.form.clusterId.options = res.data.content.map((x) => ({
            value: x.id,
            text: x.descricao
          }))
          loading.pop()
        })
        .catch(this.onException)

      loading.push()
      PARepository.GetAll()
        .then((res) => {
          this.form.paId.options = res.data.content.map((x) => ({
            value: x.id,
            text: x.numero + ' - ' + x.descricao
          }))
          loading.pop()
        })
        .catch(this.onException)

      loading.push()
      EnvironmentRepository.getEnv().then((res) => {
        this.tipoGerente = res.data.tipoPermissao
        loading.pop()
      })
    },
    loadAssociadosPa () {
      loading.push()
      AssociateRepository.Search(
        this.createFilter(),
        this.pageLimit,
        this.pageIndex
      )
        .then((res) => {
          this.associados = res.data.content.map((x) => ({
            id: x.id,
            nome: x.pessoa.nome,
            pa: x.pa.numero + ' - ' + x.pa.descricao,
            numId: x.numId,
            clusterAtual: x.clusterizacaoDTO
              ? x.clusterizacaoDTO.descricao
              : '',
            rendaBrutaMensal: x.rendaBrutaMensal
              ? Tools.formatMoneyBR(x.rendaBrutaMensal)
              : '',
            tipoPessoa: x.pessoa.tipoPessoa
          }))
          this.$refs.AssociatePagination.totalPages = res.data.totalPages
          this.$refs.AssociatePagination.totalElements = res.data.totalElements
          this.$refs.AssociatePagination.numberOfElementsDisplayed =
            res.data.numberOfElements
          this.$refs.AssociatePagination.offset = res.data.pageable.offset

          loading.pop()
        })
        .catch(this.onException)
    },
    onSearch () {
      this.onClearPaging()
      this.LoadPage(this.pageIndex)
      this.allSelected = false
    },
    onClear () {
      this.clearForm()
      this.form.nomeAssociado.value = ''
      this.rendaInicial = null
      this.rendaFinal = null
      this.form.gerenteId.value = null
      this.form.paId.value = null
      this.form.clusterId.value = null
      this.form.isProdutorRural.value = null
      this.form.tipoPessoa.value = null
      this.onClearPaging()
    },
    createFilter () {
      let string = ''
      let params = []

      if (this.form.paId.value) params.push('paId=' + this.form.paId.value)
      if (this.form.nomeAssociado.value) {
        params.push('nomeAssociado=' + encodeURI(this.form.nomeAssociado.value))
      }

      if (this.form.gerenteId.value) {
        if (this.tipoGerente === 'GERENTERELACIONAMENTO') {
          params.push('gerenteRelacionamentoId=' + this.form.gerenteId.value)
        } else {
          params.push('gerenteId=' + this.form.gerenteId.value)
        }
      }

      if (this.rendaInicial > 0) {
        params.push('rendaInicial=' + this.rendaInicial)
      }
      if (this.rendaFinal > 0) params.push('rendaFinal=' + this.rendaFinal)
      if (this.form.isProdutorRural.value) {
        params.push('isProdutorRural=' + this.form.isProdutorRural.value)
      }
      if (this.form.tipoPessoa.value) {
        params.push('tipoPessoa=' + this.form.tipoPessoa.value)
      }

      string = params.join('&')
      return string
    },
    onClearPaging () {
      this.currentPage = 0
      this.pageIndex = 0
      this.$refs.AssociatePagination.currentPage = this.currentPage
      this.$refs.AssociatePagination.pageIndex = this.pageIndex
      this.$refs.AssociatePagination.totalElements = this.totalElements
      this.$refs.AssociatePagination.numberOfElementsDisplayed =
        this.numberOfElements
      this.$refs.AssociatePagination.offset = this.offset
    },
    updateClusters () {
      if (!Tools.ValidateForms(this.form, this.data, this, toast)) {
        toast.warning('Erro atualizar cluster')
        return
      }
      if (this.allSelected) {
        this.data.associadoId = []
        if (!Tools.ValidateForms(this.form, this.dataFilters, this, toast)) {
          toast.warning('Erro atualizar cluster')
          return
        }
        this.data.filters = {
          ...this.dataFilters,
          rendaInicial: this.rendaInicial,
          rendaFinal: this.rendaFinal
        }
      } else {
        if (this.selected.length < 1) {
          toast.warning('Nenhum associado selecionado')
          return
        }
        this.data.associadoId = this.selected
      }
      loading.push()
      AssociateRepository.updateAllCluster(this.data)
        .then(() => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.reloadPage()
        })
        .catch(this.onException)
    },
    reloadPage () {
      this.selected = []
      this.searchValue = ''
      this.associados = []
      this.onSearch()
    },
    LoadPage (index) {
      this.currentPage = index
      this.pageIndex = index
      if (this.searchValue !== null && this.searchValue !== '') {
        this.loadAssociadosPaWithFilter()
      } else {
        this.loadAssociadosPa()
      }
      var obj = document.getElementById('associate-list')
      obj.scrollTo(0, 0)
      // window.scrollTo(0, 0)
    },
    loadAssociadosPaWithFilter () {
      loading.push()
      AssociateRepository.Search(
        this.createFilter(),
        this.pageLimit,
        this.pageIndex
      )
        .then((res) => {
          this.associados = res.data.content.map((x) => ({
            id: x.id,
            nome: x.pessoa.nome,
            pa: x.pa.numero + ' - ' + x.pa.descricao,
            numId: x.numId,
            clusterAtual: x.clusterizacaoDTO
              ? x.clusterizacaoDTO.descricao
              : '',
            rendaBrutaMensal: x.rendaBrutaMensal
              ? Tools.formatMoneyBR(x.rendaBrutaMensal)
              : '',
            tipoPessoa: x.pessoa.tipoPessoa
          }))
          this.$refs.AssociatePagination.totalPages = res.data.totalPages
          this.$refs.AssociatePagination.totalElements = res.data.totalElements
          this.$refs.AssociatePagination.numberOfElementsDisplayed =
            res.data.numberOfElements
          this.$refs.AssociatePagination.offset = res.data.pageable.offset

          loading.pop()
        })
        .catch(this.onException)
    },
    openConfirmationModal () {
      this.$nextTick(() => {
        this.$refs['AddConfirmationModal'].showModal()
      })
    },
    handleSelectGerente (selectedValue) {
      this.form.gerenteId.value = Array.isArray(selectedValue)
        ? selectedValue.map((v) => (v.hasOwnProperty('value') ? v.value : v))
        : selectedValue.hasOwnProperty('value')
          ? selectedValue.value
          : selectedValue
    },
    clearField (field) {
      this.form[field] = null
    },
    clearForm () {
      this.$root.$emit('clearForm')
    }
  }
}
</script>

<style scoped>
td {
  background-color: whitesmoke;
}
.input-group {
  background-color: whitesmoke;
}
thead {
  position: sticky;
  top: 0;
  z-index: 1;
}
v-select {
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/movimentacoes/clusters/link.vue